import React from "react";
import { useDispatch } from "react-redux";
import { string } from "prop-types";
import ButtonsDropdownOption from "@visiblethread/react-components/dist/components/Dropdown/ButtonsDropdownOption";
import {
  TooltipTrigger,
  tooltipPlacement,
} from "@visiblethread/react-components/dist/components/Tooltip";
import { ReactComponent as BinIcon } from "icons/trash.svg";
import {
  deleteSnapshot,
  fetchSnapshot,
} from "slices/discovery/actions/snapshot";

const SnapshotsDropdownOption = ({ name, author }) => {
  const dispatch = useDispatch();

  const handleOptionClick = () => {
    dispatch(fetchSnapshot(name));
  };

  const handleDeleteSnapshot = (e) => {
    e.stopPropagation();
    dispatch(deleteSnapshot(name));
  };

  return (
    <ButtonsDropdownOption
      content={
        <TooltipTrigger
          content={author}
          placement={tooltipPlacement.left}
          delay={200}
        >
          <div className="discovery_snapshots_controls__dropdown_option">
            <span className="discovery_snapshots_controls__dropdown_option__name">
              {name}
            </span>
            <BinIcon
              width={9}
              className="discovery_snapshots_controls__dropdown_option__bin_icon"
              onClick={handleDeleteSnapshot}
            />
          </div>
        </TooltipTrigger>
      }
      className="discovery_snapshots_controls__dropdown_option_button"
      onClick={handleOptionClick}
    />
  );
};

SnapshotsDropdownOption.propTypes = {
  name: string.isRequired,
  author: string.isRequired,
};

export default SnapshotsDropdownOption;
